export function getKismetClientId(): string {
  // Access the implementation object in a way that bypasses TypeScript checking
  const config = window.KismetConfig as any;
  const clientId = config?.implementation?.clientId;
  if (!clientId) return "";
  // Put in Kismet branding into session storage
  return clientId;
}
